import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  separator: {
    marginTop: 32
  },
  restrictionTitleContainer: {
    position: 'relative',
    top: -10,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  restrictionTitle: {
    backgroundColor: theme.palette.background.default,
    paddingLeft: 8,
    paddingRight: 8,
    width: 'fit-content'
  },
  basicDetails: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '1fr 1fr',
      gridTemplateColumns: '1fr'
    }
  },
  basicDetailsSingleInput: {
    gridTemplateColumns: '1fr'
  },
  addRestrictionButton: {
    marginTop: 24
  },
  restrictionsHeader: {
    display: 'grid',
    gridTemplateColumns: '4fr 24fr 27fr 8fr 24fr 1fr',
    gap: 12,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 20
    }
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 30
  },
  confirmButton: {
    marginLeft: 8
  },
  restrictionsHeaderSkeleton: {
    padding: '20px 0',
    height: '100%',
    backgroundColor: 'Aquamarine',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  textSkeleton: {
    backgroundColor: 'red'
  },
  noDataImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 400
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  hidden: {
    opacity: 0
  }
}))

export default useStyles
